$(function () {
  // 轮播图
  new Swiper("#swiperFirst", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: "auto",
    pagination: {
      el: ".rule_gxh_pagination",
      clickable: true,
    },
  });
  new Swiper("#swiperSecond", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: "auto",
    pagination: {
      el: ".rule_ll_pagination",
      clickable: true,
    },
  });
  new Swiper(".city_container", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: "auto",
    pagination: {
      el: ".city_pagination",
      clickable: true,
    },
  });
  new Bselector({
    showSelected: "#selectCourse",
    inputSelected: ".hiddenCourse",
    options: [
      {
        text: "雅思",
      },
      {
        text: "托福",
      },
      {
        text: "SAT",
      },
    ],
  });
  new Bselector({
    showSelected: "#selectCity",
    inputSelected: ".hiddenCity",
    options: [
      {
        text: "北京市",
      },
      {
        text: "天津市",
      },
      {
        text: "上海市",
      },
      {
        text: "重庆市",
      },
      {
        text: "河北省",
      },
      {
        text: "河南省",
      },
      {
        text: "广东省",
      },
      {
        text: "辽宁省",
      },
      {
        text: "湖南省",
      },
      {
        text: "四川省",
      },
      {
        text: "安徽省",
      },
      {
        text: "山东省",
      },
      {
        text: "江苏省",
      },
      {
        text: "浙江省",
      },
      {
        text: "湖北省",
      },
      {
        text: "山西省",
      },
      {
        text: "陕西省",
      },
      {
        text: "福建省",
      },
      {
        text: "江西省",
      },
      {
        text: "广西省",
      },
      {
        text: "甘肃省",
      },
      {
        text: "黑龙江省",
      },
      {
        text: "内蒙古",
      },
      {
        text: "吉林省",
      },
      {
        text: "新疆维吾尔",
      },
      {
        text: "贵州省",
      },
      {
        text: "云南省",
      },
      {
        text: "青海省",
      },
      {
        text: "西藏",
      },
      {
        text: "宁夏回族",
      },
      {
        text: "海南省",
      },
    ],
  });

  $(".course_content_btn").click(function () {
    $(".toast").fadeIn();
  });
  $(".ad_btn").click(function () {
    $(".toast").fadeIn();
  });

  $(".toast_icon").click(function(){
    $(".toast").fadeOut()
    setTimeout(function(){
      $(".toast").fadeIn()
    },7000)
  })

  setTimeout(function(){
    $(".toast").fadeIn()
  },7000)

  $(".toast_content").listenForm({
    contentName: [
      {
        search: "?jtppzq",
        name: "web4R个性化课程（百品）",
      },
      {
        search: "?360jtppzq",
        name: "web4R个性化课程（360）",
      },
      {
        search: "?tg",
        name: "web4R个性化课程（原生）",
      },
      {
        search: "",
        name: "web4R个性化课程",
      },
    ],
    submitTarget: ".toast_input",
    courseRequired: true,
    cityRequired: true,
    emailRequired: true,
  });
  
});
